<div class="token-profile-validator">
  <div class="profile-image">
    <img [src]="validationImage" alt="Token profile image">
  </div>
  <div class="token-profile-form-section">
    <form class="token-profile-form" [formGroup]="hopiTokenValidationForm">
      <ng-container dynamicField [group]="hopiTokenValidationForm" [fields]="[fieldConfig]">
      </ng-container>
      <!--       Action Button      -->
      <!--            <div class="validate-btn">-->
      <!--                <button mat-flat-button-->
      <!--                        type="button"-->
      <!--                        (click)="onValidateProfile()"-->
      <!--                        [color]="isDiscountApplied ? 'warn':'primary'">-->
      <!--                    {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}-->
      <!--                </button>-->
      <!--            </div>-->
    </form>
  </div>
</div>



